module.exports = __webpack_public_path__ + "img/done.a5e4b7da.svg";